import React from 'react'

import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import { CuratedProductImage } from 'tripPlanner/components/CuratedItemSelection/CuratedProductImage'
import useOffer from 'hooks/Offers/useOffer'
import { AccommodationItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: AccommodationItem
  onSelect: () => void
  isSelected: boolean
}

function getOfferImage(
  offer:
    | App.BedbankOffer
    | Tours.V2Offer
    | App.Offer
    | App.CruiseOffer
    | undefined,
) {
  if (!offer || offer.parentType === 'tour_v2') {
    return {}
  }
  const image = (offer as App.Offer).image
  if (image?.id) {
    return { imgId: image.id }
  } else if (image?.url) {
    return { imgSrc: image.url }
  }
  return {}
}

export function CuratedAccommodationItemSelection({
  item,
  onSelect,
  isSelected,
}: Props) {
  let offerId: string | undefined
  if (
    (item.sourceType === 'LE_Hotel' ||
      item.sourceType === 'LE_Hotel_Bedbank') &&
    item.code
  ) {
    offerId = item.code
  }

  const [offer] = useOffer<App.Offer | App.BedbankOffer>(offerId)

  const { imgId, imgSrc } = getOfferImage(offer)
  return (
    <CuratedBaseItemSelection
      type={item.type}
      title={item.place.name}
      onSelect={onSelect}
      isSelected={isSelected}
      image={
        <CuratedProductImage
          item={item}
          imgId={imgId}
          imgSrc={imgSrc}
          placeId={'id' in item.place ? item.place.id : undefined}
        />
      }
    />
  )
}
